import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import dashboardsApi from 'common/src/modules/dashboards/dashboards.api';
import {handleApiError} from 'common/src/modules/errorHandling/handleApiError';
import {updateWidgets} from '../dashboardPage.slice';

export const refreshDashboardWidgets = createAsyncThunk<void, {dashboardId: number}>(
  `${BreadcrumbName.CampaignInsights}/refreshWidgets`,
  async ({dashboardId}, {dispatch}) => {
    try {
      const widgets = await dashboardsApi.getWidgets(dashboardId);

      dispatch(updateWidgets(widgets));
    } catch (error) {
      handleApiError(error);
    }
  },
);
